import axios from 'axios'
import LoraApiService from '../../services/LoraApiService'
import _ from 'lodash'
import Vue from 'vue'
import { azureAD } from '../../const'

export const namespaced = true
export const state = {
  loggedInUser: null,
  tokenInfo: null,
  permissions: [],
  loading: 0,
  token_refreshing: false,
  no_token_rquest: [],
  no_loading_request: [
    '/Data/LatestPodChartDataPoint',
    '/data/LatestCaliPodChartDataPoint',
    '/Data/LatestRecords'
  ]
}

export const mutations = {
  SET_LOADING: (state, loading) => {
    state.loading = state.loading + loading
  },
  STOP_LOADING: state => {
    state.loading = 0
  },
  SET_USER_DATA(state, userData) {
    state.loggedInUser = userData
    localStorage.setItem('user', JSON.stringify(userData))
  },
  SET_TOKEN_INFO(state, tokenInfo) {
    tokenInfo.expires_at = Date.now() + tokenInfo.expires_in * 1000
    state.tokenInfo = tokenInfo
    localStorage.setItem('tokenInfo', JSON.stringify(tokenInfo))
  },
  SET_TOKEN_REFRESHING(state, val) {
    state.token_refreshing = val
  },
  SET_PERMISSIONS(state, permissions) {
    _.assignIn(state, permissions)
    localStorage.setItem('permissions', JSON.stringify(permissions))
  },
  LOGOUT() {
    localStorage.removeItem('user')
    localStorage.removeItem('tokenInfo')
    localStorage.removeItem('permissions')
    localStorage.removeItem('codeVerifier')
  }
}

export const getters = {
  auth: () => module =>
    _.includes(JSON.parse(localStorage.getItem('permissions')), module),
  user: () => module =>
    JSON.parse(localStorage.getItem('user')) &&
    JSON.parse(localStorage.getItem('user')).username === module
}

export const actions = {
  getAzureToken({ commit }, code) {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams()
      params.append('grant_type', 'authorization_code')
      params.append('client_id', azureAD.clientId)
      params.append('scope', azureAD.scope)
      params.append('code', code)
      params.append('redirect_uri', azureAD.redirectUri)
      params.append('code_verifier', localStorage.getItem('codeVerifier') || '')

      axios
        .post(
          `https://login.microsoftonline.com/${azureAD.tenantId}/oauth2/v2.0/token`,
          params,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(response => {
          commit('SET_TOKEN_INFO', response.data)
          resolve(response)
        })
        .catch(reject)
    })
  },

  verifyUser({ commit }) {
    return new Promise((resolve, reject) => {
      LoraApiService.getUserInfo()
        .then(response => {
          const data = response.data
          commit('SET_USER_DATA', {
            id: data.userId,
            username: data.email,
            email: data.email,
            displayName: data.fullName
          })
          let permissions = []
          if (data.roles && data.roles.length) {
            data.roles.forEach(role => {
              role.modules.forEach(module => {
                module.childModules.forEach(childModule => {
                  childModule.permissions.forEach(ele => {
                    if (ele.isActive) {
                      permissions.push(
                        module.name + '.' + childModule.name + '.' + ele.name
                      )
                    }
                  })
                })
              })
            })
          }
          permissions = [...new Set(permissions)]
          commit('SET_PERMISSIONS', permissions)
          resolve(response)
        })
        .catch(reject)
    })
  },

  refreshAzureToken({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      const tokenInfo = JSON.parse(localStorage.getItem('tokenInfo'))
      const refreshToken = tokenInfo && tokenInfo.refresh_token
      if (!refreshToken) return reject(new Error('no refresh token'))

      commit('SET_TOKEN_REFRESHING', true)
      const params = new URLSearchParams()
      params.append('grant_type', 'refresh_token')
      params.append('client_id', azureAD.clientId)
      params.append('scope', azureAD.scope)
      params.append('refresh_token', refreshToken)

      axios
        .post(
          `https://login.microsoftonline.com/${azureAD.tenantId}/oauth2/v2.0/token`,
          params,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(response => {
          commit('SET_TOKEN_INFO', response.data)
          commit('SET_TOKEN_REFRESHING', false)
          resolve(response.data)
        })
        .catch(err => {
          commit('SET_TOKEN_REFRESHING', false)
          dispatch('logout')
          reject(err)
        })
    })
  },

  logout({ commit }) {
    if (Vue.prototype.stopSignalR) {
      Vue.prototype.stopSignalR()
    }
    commit('LOGOUT')
    window.open(
      `https://login.microsoftonline.com/${azureAD.tenantId}/oauth2/v2.0/logout` +
        `?post_logout_redirect_uri=${encodeURIComponent(azureAD.redirectUri)}`,
      '_self'
    )
  }
}
